import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { StyledColumnSecondary, StyledLink } from 'src/presentation/components/pages/home/elements';
import ExternalLink from 'src/presentation/components/pages/shared/ExternalLink';
import { H2 } from '@ad-scripts/presentation/components/common/headers';

export const StyledColumnSecondaryBlock = styled.div`
  ${StyledColumnSecondary}
`;

export const StyledGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 16px;
  margin: 24px 0 40px 0;

  @media (max-width: 1050px) {
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  }
`;

export const StyledCardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 16px;
  margin: 24px 0 40px 0;
  @media (max-width: 1150px) {
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  }
`;

export const StyledGridContainerMiddle = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-gap: 16px;
  grid-row-gap: 56px;
  margin: 24px 0 40px 0;

  @media (max-width: 1350px) {
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  }

  @media (max-width: 1250px) {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }
`;

export const StyledCardTitle = styled.div`
  font-size: ${p => p.fontSize || 16}px;
  font-weight: bold;
`;

export const StyledCardDescription = styled.div`
  margin-top: 8px;
  margin-bottom: 24px;
  line-height: 21px;
`;

export const StyledCard = styled.div`
  position: relative;
  border: 1px solid ${p => p.theme.colors.gray300};
  background-color: ${p => (p.bgColor ? p.theme.colors[p.bgColor] : '')};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: ${p => p.height || '100%'};
  padding: ${p => p.padding || '24px 24px 24px 88px'};
`;

export const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  > svg {
    width: 24px;
    fill: ${p => p.theme.colors.green400};
    margin-bottom: 18px;
  }
`;

export const StyledColumnLink = styled(Link)`
  margin-top: 20px;
  display: flex;
  align-items: center;

  svg {
    width: 16px;
    margin-left: 4px;
    fill: ${p => p.theme.colors.green400};
  }
`;

export const StyledH2 = styled(H2)`
  margin-bottom: 0;
`;

export const ButtonExternalLink = styled(ExternalLink)`
  padding: 8px 16px;
  border-radius: 20px;
  color: ${p => p.theme.colors.white};
  background-color: ${p => p.theme.colors.green400};
`;

export const StyledExternalLink = styled(StyledLink).attrs({ rel: 'noopener noreferrer', target: '_blank' })``;
